module.exports = __webpack_public_path__ + "img/NL300.2897d9d3.png";